import React from 'react';

import gridCalculator from './gridCalculator';

const Gutter = () => {
  const styles = {
    gutter: {
      width: `${gridCalculator.GUTTER_WIDTH}px`,
      height: `${gridCalculator.GUTTER_HEIGHT}px`,
    },
  };
  return <div style={styles.gutter} />;
};

export default Gutter;
